import axios from "axios";
import Cookies from "js-cookie";
import { API_BASE_URL } from "./config";

const instance = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

instance.interceptors.request.use((config) => {
  const employeeToken = Cookies.get("employeeToken");
  const consultantToken = Cookies.get("ConsultantToken");

  const token = consultantToken || employeeToken;

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

//  Prevent instant redirect during page load
let isRedirecting = false;

instance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401 && !isRedirecting) {
      isRedirecting = true;

      const isConsultant = Cookies.get("ConsultantToken");
      const isEmployee = Cookies.get("employeeToken");

      // Clear only invalid session
      Cookies.remove("ConsultantToken");
      Cookies.remove("employeeToken");

      setTimeout(() => {
        if (isConsultant) {
          window.location.href = "/Consultant-Login";
        } else if (isEmployee) {
          window.location.href = "/Employee-Login";
        } else {
          window.location.href = "/";
        }
      }, 1000);
    }

    return Promise.reject(error);
  }
);

export default instance;
